import { Button, ButtonProps } from '@mui/material';
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface AnimatedIconButtonProps extends Omit<ButtonProps, 'startIcon'> {
  icon: React.ReactNode;
  to?: string;
  external?: boolean;
}

export const AnimatedIconButton: React.FC<AnimatedIconButtonProps> = ({
  icon,
  children,
  onClick,
  to,
  external,
  sx,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (to && external) {
      window.open(to, '_blank');
    } else if (onClick) {
      onClick(e);
    }
  };

  const buttonProps = {
    ...props,
    sx: {
      color: 'text.primary',
      fontWeight: 'bold',
      transition: 'color 0.2s ease-in-out',
      '&:hover': {
        color: 'primary.main'
      },
      display: 'flex',
      alignItems: 'center',
      ...sx
    },
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    startIcon: (
      <motion.div
        animate={{ rotate: isHovered ? 20 : 0 }}
        transition={{ duration: 0.2 }}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {icon}
      </motion.div>
    )
  };

  const buttonContent = (
    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.95 }}>
      {to && !external ? (
        <Button component={Link} to={to} {...buttonProps}>
          {children}
        </Button>
      ) : (
        <Button onClick={handleClick} {...buttonProps}>
          {children}
        </Button>
      )}
    </motion.div>
  );

  return buttonContent;
}; 